import React, { useState } from "react";
import { Upload, message, Typography } from "antd";
import "./fileUpload.scss";
import UploadFileImg from "../../../assets/images/uploadFile.png";
const { Dragger } = Upload;

const FileUpload = ({
  action = "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  maxFileSize = 1, // Max file size in MB
  accept = ".svg,.jpg,.png",
  label,
  label2,
  maxFileSizeText,
}) => {
  const [fileList, setFileList] = useState([]);

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList.slice(-1));
  };

  const beforeUpload = (file) => {
    const isValidType = accept.includes(file.type.split("/")[1]);
    const isLtSize = file.size / 1024 / 1024 < maxFileSize;

    if (!isValidType) {
      message.error("Only SVG, JPG, and PNG files are allowed!");
      return Upload.LIST_IGNORE;
    }
    if (!isLtSize) {
      message.error(`File must be smaller than ${maxFileSize}MB!`);
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  return (
    <div className="uploadFile">
      <p className="label"> {label}</p>
      <Dragger
        action={action}
        fileList={fileList}
        onChange={handleChange}
        beforeUpload={beforeUpload}
        accept={accept}
        maxCount={1} // Restrict to only 1 file
        showUploadList={true}
        className="customDragger"
      >
        {/* Inside Upload Box */}
        <p className="label2">{label2}</p>
        <img src={UploadFileImg} alt={UploadFileImg} s />
        <p className="dragDrop">
          Drag & drop or <span> Choose file</span>
        </p>
        <Typography.Text
          type="secondary"
          style={{ fontSize: 12, marginTop: 4 }}
        >
          {maxFileSizeText}
        </Typography.Text>
      </Dragger>
    </div>
  );
};

export default FileUpload;
